import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import tw from 'twin.macro';

export const VegOnlyWrapper = styled.div`
  ${tw`flex items-center justify-end text-sm`}
  /* width: 100%; */
  background-color: transparent;
  label {
    ${tw`flex items-center`}
  }
`;

export const LocaleItem = styled.button`
  ${tw`px-3 py-1 mx-1 bg-primary-lighter inline-block rounded border-0 cursor-pointer`}
  &.active {
    ${tw`bg-primary text-white`}
  }
  &:last-child {
    /* ${tw`mr-0`} */
  }
`;
